/* tslint:disable */
/* eslint-disable */
/**
 * API
 * API
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { AreaOfInterestDto } from '../models';
/**
 * RestAreaOfInterestsApi - axios parameter creator
 * @export
 */
export const RestAreaOfInterestsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary get active area of interests
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getActiveAreaOfInterests: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/area-of-interests`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * RestAreaOfInterestsApi - functional programming interface
 * @export
 */
export const RestAreaOfInterestsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = RestAreaOfInterestsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary get active area of interests
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getActiveAreaOfInterests(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<AreaOfInterestDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getActiveAreaOfInterests(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RestAreaOfInterestsApi.getActiveAreaOfInterests']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * RestAreaOfInterestsApi - factory interface
 * @export
 */
export const RestAreaOfInterestsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = RestAreaOfInterestsApiFp(configuration)
    return {
        /**
         * 
         * @summary get active area of interests
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getActiveAreaOfInterests(options?: RawAxiosRequestConfig): AxiosPromise<Array<AreaOfInterestDto>> {
            return localVarFp.getActiveAreaOfInterests(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * RestAreaOfInterestsApi - interface
 * @export
 * @interface RestAreaOfInterestsApi
 */
export interface RestAreaOfInterestsApiInterface {
    /**
     * 
     * @summary get active area of interests
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RestAreaOfInterestsApiInterface
     */
    getActiveAreaOfInterests(options?: RawAxiosRequestConfig): AxiosPromise<Array<AreaOfInterestDto>>;

}

/**
 * RestAreaOfInterestsApi - object-oriented interface
 * @export
 * @class RestAreaOfInterestsApi
 * @extends {BaseAPI}
 */
export class RestAreaOfInterestsApi extends BaseAPI implements RestAreaOfInterestsApiInterface {
    /**
     * 
     * @summary get active area of interests
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RestAreaOfInterestsApi
     */
    public getActiveAreaOfInterests(options?: RawAxiosRequestConfig) {
        return RestAreaOfInterestsApiFp(this.configuration).getActiveAreaOfInterests(options).then((request) => request(this.axios, this.basePath));
    }
}

